<template>
  <el-tree
    :data="data"
    ref="tree"
    :load="loadNode1"
    @node-click="treeNodeClick"
    @check-change="handleCheckChange"
    :filter-node-method="filterNode"
    :filterText="filterText"
    node-key="id"
    empty-text=' '
    :default-checked-keys="defaultChecked"
    :show-checkbox="showCheckBox">
  </el-tree>
</template>

<script>
  export default {
     watch: {
      'filterText': {
        handler(c, o) {
          this.$refs.tree.filter(c);
        },
        deep: true
      }
    },
    props: {
      filterText: {
        type: String,
        default: ''
      },
      showCheckBox: {
        type: Boolean,
        default: false
      },
      data: {
        type: Array,
        default() {
          return []
        }
      },
      defaultChecked: {
        type: Array,
        default() {
          return []
        }
      }
    },
    data() {
      return {
        props1: {
          label: 'name',
          children: 'zones',
          isLeaf: 'leaf'
        },
      };
    },
    methods: {
      loadNode1(node, resolve) {
        if (node.level === 0) {
          return resolve([{name: 'region'}]);
        }
        if (node.level > 1) return resolve([]);

        setTimeout(() => {
          const data = [{
            name: 'leaf',
            leaf: true
          }, {
            name: 'zone'
          }];

          resolve(data);
        }, 500);
      },
      filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },
      treeNodeClick(data) {
        this.$emit('treeNodeClick', data)
      },
      handleCheckChange() {
        this.$emit('checkTree', this.$refs.tree.getCheckedNodes())
      }
    },
    created() {
      // console.log('tree')
      // console.log(this.defaultChecked)
    }
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// tree.vue?65ba043a